import { Box, CircularProgress } from '@mui/material';

import useStyles from './LoadingIndicator.styles';

/*
 noBackground prop will make background transparent
*/
export const LoadingIndicator = ({
  isLoading,
  noBackground
}: {
  isLoading: boolean;
  noBackground?: boolean;
}) => {
  const { classes } = useStyles({ noBackground });

  return isLoading ? (
    <Box className={classes.loadingIndicator}>
      <CircularProgress />
    </Box>
  ) : null;
};

export default LoadingIndicator;
